import { useAuthContext } from '../contexts/AuthContext';

export function useReadOnly(): boolean {
  const { isReadOnly } = useAuthContext();
  return isReadOnly;
}
